// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3933":"02e7c099","5151":"c16ad669","7080":"02e7c099"}[chunkId] + ".chunk.css";
};